import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import Modal from './Modal';
import { fireGTM } from '../../../gtm/gtmUtil';
import { getTenantDegrees, setModalImage } from '../../../store/actions';
import { getTenantState } from '../../../store/selectors';
import { modalClose_GTM } from '../../../gtm/datalayers/utilDataLayers.json';

class ModalController extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      degreeList: [],
      focusX: true,
    };
  }

  async componentDidMount() {
    try {
      this._isMounted = true;

      const allDegrees = await this.props.getTenantDegrees(
        this.props.tenant.id
      );

      if (this._isMounted) {
        this.setState({
          degreeList: allDegrees,
        });
      }
    } catch (e) {
      if (this._isMounted) {
        this.setState({
          degreeList: [],
        });
      }

      console.error(e);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async componentDidUpdate(prevProps) {
    if (this.props.currentLocale !== prevProps.currentLocale) {
      const allDegrees = await this.props.getTenantDegrees(
        this.props.tenant.id
      );

      if (this._isMounted) {
        /* eslint-disable-next-line react/no-did-update-set-state */
        this.setState({
          degreeList: allDegrees,
        });
      }
    }
  }

  findDegree = (degree, id) => {
    return this.state.degreeList.find(
      (tenantDegree) =>
        tenantDegree.titleEn.trim() === degree.trim() &&
        tenantDegree.id === parseInt(id, 10)
    );
  };

  findCareer = (career) => {
    return this.props.tenant.allTenantCareers.find(
      (tenantCareer) => tenantCareer.titleEn === career
    );
  };

  get degree() {
    const params = new URLSearchParams(this.props.location.search);
    const degreeURL = params.get('degree');

    if (!degreeURL) return null;

    const [degree, id] = degreeURL.split('degreeId');

    return this.findDegree(degree, id);
  }

  get career() {
    const params = new URLSearchParams(this.props.location.search);
    const career = params.get('career');
    return this.findCareer(career);
  }

  get comparisonCareer() {
    const params = new URLSearchParams(this.props.location.search);
    const comparisonCareer = params.get('career2');

    return this.findCareer(comparisonCareer);
  }

  get comparisonDegree() {
    const params = new URLSearchParams(this.props.location.search);
    const comparisonDegree = params.get('degree2');

    if (!comparisonDegree) return undefined;

    const [degree, id] = comparisonDegree.split('degreeId');

    return this.findDegree(degree, id);
  }

  showModal1 = () => !isEmpty(this.degree) || !isEmpty(this.career);

  closeModal = async (item, userProfileId, userProfileTenantId) => {
    const searchParams = new URLSearchParams(this.props.location.search);

    searchParams.delete('swap');

    if (this.degree && (item ? this.degree.titleEn === item.titleEn : true)) {
      fireGTM(modalClose_GTM, 'close cross', this.degree.titleEn);

      const degree2 = searchParams.get('degree2');

      if (degree2) {
        searchParams.set('degree', degree2);
        searchParams.delete('degree2');
      } else {
        searchParams.delete('degree');
      }

      this.props.setModalImage(null);
      this.setState({
        focusX: false,
      });
    }

    if (this.career && (item ? this.career.titleEn === item.titleEn : true)) {
      fireGTM(modalClose_GTM, 'close cross', this.career.titleEn);

      const career2 = searchParams.get('career2');

      if (career2) {
        searchParams.set('career', career2);
        searchParams.delete('career2');
      } else {
        searchParams.delete('career');
      }

      this.props.setModalImage(null);
    }

    if (
      this.comparisonCareer &&
      (item ? this.comparisonCareer.titleEn === item.titleEn : true)
    ) {
      fireGTM(modalClose_GTM, 'close cross', this.comparisonCareer.titleEn);
      searchParams.delete('career2');
      document.getElementById('close-modal-x-icon').focus();
    }

    if (
      this.comparisonDegree &&
      (item ? this.comparisonDegree.titleEn === item.titleEn : true)
    ) {
      fireGTM(modalClose_GTM, 'close cross', this.comparisonDegree.titleEn);
      searchParams.delete('degree2');
      document.getElementById('close-modal-x-icon').focus();
    }

    if (!item) {
      searchParams.delete('career');
      searchParams.delete('career2');
      searchParams.delete('degree');
      searchParams.delete('degree2');
    }

    if (this.props.location.pathname.includes('user-profile')) {
      searchParams.set('userId', userProfileId);
      searchParams.set('tenantId', userProfileTenantId);
    }

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: `?${searchParams}`,
      state: this.props.location.pathname.includes('user-profile')
        ? {
            userId: userProfileId,
            tenantId: userProfileTenantId,
          }
        : null,
    });
  };

  renderTabs() {
    if (isEmpty(this.comparisonCareer)) return null;

    const searchOriginal = new URLSearchParams(this.props.location.search);

    searchOriginal.set('swap', true);

    const searchComparison = new URLSearchParams(this.props.location.search);

    searchComparison.set('swap', false);

    return (
      <div className="modal-tabs-container">
        <div
          className="modal-tabs"
          style={{
            borderBottom: `3px solid ${this.props.tenant.primary}`,
          }}
        >
          <NavLink
            className="modal-tabs-tab"
            activeClassName="modal-tabs-tab--active"
            to={{
              ...(this.props.location || {}),
              search: searchOriginal.toString(),
            }}
            isActive={(match, location) => {
              return (
                new URLSearchParams(location.search).get('swap') !== 'false'
              );
            }}
          >
            {this.career.titleEn}
          </NavLink>
          <div className="modal-tabs-separator" />
          <NavLink
            className="modal-tabs-tab"
            activeClassName="modal-tabs-tab--active"
            to={{
              ...(this.props.location || {}),
              search: searchComparison.toString(),
            }}
            isActive={(match, location) => {
              return (
                new URLSearchParams(location.search).get('swap') === 'false'
              );
            }}
          >
            {this.comparisonCareer.titleEn}
          </NavLink>
        </div>
      </div>
    );
  }

  checkForSecondModal = () => {
    const search = new URLSearchParams(this.props.location.search);

    if (!isEmpty(this.comparisonCareer) || !isEmpty(this.comparisonDegree)) {
      let compareDegreeKey;

      if (!isEmpty(this.comparisonDegree)) {
        compareDegreeKey =
          this.comparisonDegree.titleEn === this.degree.titleEn
            ? `${this.comparisonDegree}_2`
            : this.comparisonDegree;
      }
      return (
        <Modal
          key={
            (
              this.comparisonCareer ||
              compareDegreeKey || { id: 'modal-default-2' }
            ).id
          }
          focusX={this.state.focusX}
          career={this.comparisonCareer}
          tenant={this.props.tenant}
          degree={this.comparisonDegree}
          closeModal={this.closeModal}
          careerToCompare={null}
          degreeToCompare={null}
          second
          modalClassName={classNames({
            modal1: true,
            'responsive-modal': true,
            'responsive-modal--top': search.get('swap') === 'false',
          })}
        >
          {this.renderTabs()}
        </Modal>
      );
    }

    return null;
  };

  render() {
    const search = new URLSearchParams(this.props.location.search);

    return (
      <>
        {this.showModal1() ? (
          <Modal
            key={(this.degree || this.career || { id: 'modal-default-1' }).id}
            career={this.career}
            tenant={this.props.tenant}
            degree={this.degree}
            focusX={this.state.focusX}
            closeModal={this.closeModal}
            careerToCompare={this.comparisonCareer}
            degreeToCompare={this.comparisonDegree}
            modalClassName={classNames({
              'modal1 modal1-animation':
                isEmpty(this.comparisonCareer) &&
                isEmpty(this.comparisonDegree),
              modal2:
                !isEmpty(this.comparisonCareer) ||
                !isEmpty(this.comparisonDegree),
              'responsive-modal': true,
              'responsive-modal--top':
                search.get('swap') !== 'false' ||
                isEmpty(this.comparisonCareer) ||
                isEmpty(this.comparisonDegree),
            })}
          >
            {this.renderTabs()}
          </Modal>
        ) : null}
        {this.checkForSecondModal()}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const currentLocale = state.currentLocale;

  return { tenant, currentLocale };
};

const ConnectedModalController = withRouter(
  connect(mapStateToProps, {
    getTenantDegrees,
    setModalImage,
  })(ModalController)
);

export default ConnectedModalController;
